export const SCHLAEGE_SOURCE = 'invekos_schlaege_polygon';
export const SCHLAEGE_LAYER = 'invekos_schlaege_polygon-fill';
export const AGRARATLAS_STYLE_URL = 'https://agraratlas.inspire.gv.at/map/style-pmtiles.json';
export const INITIAL_EXTENT = [8.782379, 46.35877, 17.5, 49.037872];
